module.exports = __webpack_public_path__ + "img/274395076_109427115008132_7254412294432179318_n.3cabab61.jpg";